import { jsx as _jsx } from "react/jsx-runtime";
import { LiveMessage } from 'react-aria-live';
export const PageLoadedMessage = ({ pageLoadedMessage }) => {
    return _jsx(LiveMessage, { "aria-live": "polite", message: pageLoadedMessage });
};
